// redux/services/dashboardApi.js

import { baseApi } from "../baseApi";

export const dashboardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    getDashboardSummary: builder.query({
      query: () => ({
        url: "/dashboard-summary",
        method: "GET",
      }),
      providesTags: ["Dashboard"],
    }),

  }),
});

export const {
  useGetDashboardSummaryQuery
} = dashboardApi;